import { resolveImageSrc } from "@/shared/ui/AppImage";

export function IssuerDocumentAssetImg({
  fileKey,
  className,
}: {
  fileKey: string | null | undefined;
  className: string;
}) {
  const url = resolveImageSrc(fileKey);
  if (!url) return null;
  return <img src={url} alt="" className={className} />;
}
